<script lang="ts" setup>
import { useDialogsStore } from '@/store/dialogs/dialogs'
import { DIALOGS } from '@/store/dialogs/dialogs.constants'

const { showDialog } = useDialogsStore()

type Props = { cityName: string }

const props = defineProps<Props>()

const showDialogCityChange = () => {
  showDialog(DIALOGS.CITY_CHANGE, { cityName: props.cityName })
}
</script>

<template>
  <div class="header-city-select">
    <span
      class="header-city-select__text"
      data-e2e="toggle-city-list"
      @click="showDialogCityChange"
    >
      {{ cityName }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.header-city-select {
  font-size: 12px;
  font-weight: 800;
  line-height: 16px;

  @include media('>=tablet') {
    font-size: 14px;
    line-height: 18px;
  }

  &__text {
    display: inline-block;
    max-width: 100px;
    color: var(--ui-color-sandy-800);

    @include media('>=tablet') {
      max-width: 110px;
      cursor: pointer;
      transition: color 0.2s ease-in;

      &:hover {
        color: var(--ui-color-coral-500);
      }
    }
  }
}
</style>
